module.exports = __webpack_public_path__ + "static/food-drinks-1-69543f580170b6a6c69f92be8f13de21.jpg";